export default __webpack_public_path__ + "static/media/icona-calavera-red.c4d958c6.svg";